import React from 'react';
import { components } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { FieldContainer, Field, Label, FieldBefore } from '../field';
import { Icon } from '../icon';
import { useFieldValidation } from '../../hooks/validation-field';
import { makeSelect, makeCustomSup } from './mixins';
import { Helper } from '../Helper';
const SelectField = styled(CreatableSelect) `
  ${(props) => makeSelect(props)}
`;
const CustomSup = styled.sup `
  ${() => makeCustomSup()}
`;
const DropdownIndicator = (props) => {
    const { hasValue, selectProps } = props;
    return ((!selectProps.isClearable || (selectProps.isClearable && !hasValue)) && (React.createElement(components.DropdownIndicator, Object.assign({}, props),
        React.createElement(Icon, { name: "icon-light-caret-down", color: "rgba(0, 0, 24, 0.16)", size: "16" }))));
};
const ClearIndicator = (props) => {
    return (React.createElement(components.ClearIndicator, Object.assign({}, props),
        React.createElement(Icon, { name: "icon-light-close", color: "rgba(0, 0, 24, 0.16)", size: "16" })));
};
export const DataList = ({ options, value, defaultValue, placeholder = 'Seleccione una opción', name, id, onChange, onBlur, disabled = false, rules, errors, control, fieldOptions, reactSelectOptions, noBottomMargin, }) => {
    const { fieldStates, classes, setValue, setActive } = useFieldValidation(rules, errors, name, disabled);
    const handleOnChange = (option, callback) => {
        setValue(option);
        callback && callback(name, option);
    };
    const handleOnBlur = (event, callback) => {
        setActive(false);
        callback && callback(event);
    };
    /**
     * Quita el listado de opciones en caso que el select se encuentre desabilitado o en caso
     * de contar con la opcion isClearable en true y un valor definido
     */
    const removeMenu = disabled || (reactSelectOptions && reactSelectOptions.isClearable && value);
    return (React.createElement(FieldContainer, null,
        fieldOptions && fieldOptions.label && (React.createElement(Label, { htmlFor: id || `select-${name}` },
            fieldOptions.label,
            rules && rules.required && React.createElement(CustomSup, null, "*"))),
        React.createElement(Field, Object.assign({}, fieldOptions, { states: Object.assign({}, fieldStates), className: classes }),
            fieldOptions && fieldOptions.before && React.createElement(FieldBefore, null, fieldOptions.before),
            rules ? (React.createElement(Controller, Object.assign({ as: React.createElement(SelectField, Object.assign({ createOptionPosition: "first", formatCreateLabel: (inputValue) => inputValue, id: id || `select-${name}`, placeholder: placeholder, options: options, isDisabled: disabled }, (removeMenu && { menuIsOpen: false }), { onMenuOpen: () => setActive(true), onBlur: (event) => handleOnBlur(event, onBlur) }, fieldOptions, reactSelectOptions, { components: { DropdownIndicator, ClearIndicator }, classNamePrefix: "select" })), defaultValue: value }, { control, rules }, { onChange: ([selected]) => {
                    handleOnChange(selected, onChange);
                    return selected;
                }, name: name }))) : (React.createElement(SelectField, Object.assign({ name: name, id: id || `select-${name}`, placeholder: placeholder, options: options, isDisabled: disabled }, (removeMenu && { menuIsOpen: false }), { onChange: (option) => handleOnChange(option, onChange), onMenuOpen: () => setActive(true), onBlur: () => setActive(false) }, fieldOptions, reactSelectOptions, { value: value, defaultValue: defaultValue, components: { DropdownIndicator, ClearIndicator }, classNamePrefix: "select" })))),
        React.createElement(Helper, { name: name, fieldOptions: fieldOptions, errors: errors, noBottomMargin: noBottomMargin })));
};
